<template>
    <UserBase>
        <div slot="content" class="page-user-certificate">
            <vue-headful 
            :title="$PPlusEngine.getDictionary($route.params.lang, 
                'ใบรับรองการฝึกอบรม - ProbPlus', 
                'Certificate - ProbPlus')" 
            :description="$PPlusEngine.getDictionary($route.params.lang, 
                'ดาวน์โหลดหรือขอใบรับรองการผ่านการฝึกอบรม',
                'Download AML Certification')" />
            <ContentLoader :isDisplay="!contentReady" />
            <template v-if="contentReady">
                <h1><span>{{ $PPlusEngine.getDictionary($route.params.lang, 'ดาวน์โหลดใบรับรอง', 'Download Certificate') }}</span></h1>
                <div class="not-allow" v-if="!fields.allowDownload">
                    <i class="pe-7s-coffee"></i>
                    {{ $PPlusEngine.getDictionary($route.params.lang, 'ท่านยังไม่ได้ผ่านการสอบวัดผล', 'You haven\'t passed the exam yet') }}
                </div>
                <div class="paper" v-if="fields.allowDownload">
                    <div class="thumbnail">
                        <img :src="fileThumbTH" alt="Certificate" title="Certificate" v-if="fileThumbTH != '' && fileThumbLoader == 0 && currentLang == 'TH'" />
                        <img :src="fileThumbEN" alt="Certificate" title="Certificate" v-if="fileThumbEN != '' && fileThumbLoader == 0 && currentLang == 'EN'" />
                        <ContentLoader :isDisplay="fileThumbLoader > 0" />
                    </div>
                    <div class="action">
                        <div class="lang">
                            <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'เลือกภาษา', 'Choose Language') }}</label>
                            <div class="group">
                                <button :class="{ 'active': currentLang == 'TH' }" @click="currentLang = 'TH'">TH</button>
                                <button :class="{ 'active': currentLang == 'EN' }" @click="currentLang = 'EN'">EN</button>
                            </div>
                        </div>
                        <div class="download">
                            <button class="btn btn-main" @click="downloadPDF()" v-if="fileThumbLoader == 0">{{ $PPlusEngine.getDictionary($route.params.lang, 'ดาวน์โหลด', 'Download') }} (<template v-if="currentLang == 'TH'">ไทย</template><template v-if="currentLang == 'EN'">English</template>)</button>
                        </div>
                        
                    </div>
                </div>
                <template v-if="fields.allowDownload">
                    <div class="certificate-container">
                        <div class="certificate" ref="panelCertificateTH">
                            <div class="wrapper">
                                <div class="logo"><img src="@/assets/cert-logo.jpg" /></div>
                                <h2>บริษัท โปรเฟสชั่นแนล บี โพสิทีฟ จำกัด</h2>
                                <p class="give-text">ขอมอบหนังสือรับรองฉบับนี้ให้ไว้เพื่อแสดงว่า</p>
                                <p class="name">คุณ{{ fields.fullnameTH }}</p>
                                <p class="topic-text">ได้ผ่านการฝึกอบรมตามหลักสูตร</p>
                                <p class="topic">
                                    "การฝึกอบรมเพื่อประโยชน์ในการปฏิบัติหน้าที่ตามกฏหมายว่าด้วยการ
                                    <br />
                                    ป้องกันและปราบปรามการฟอกเงินและการสนับสนุนทางการเงินแก่การ
                                    <br />
                                    ก่อการร้ายและการแพร่ขยายอาวุธที่มีอานุภาพทำลายล้างสูงเพื่อ
                                    <br />
                                    ผู้มีหน้าที่รายงานตามมาตรา ๑๓ และมาตรา ๑๖ พ.ศ. ๒๕๖๓"
                                </p>
                                <p class="topic-sub-text">
                                    ตามระเบียบคณะกรรมการป้องกันและปราบปรามการฟอกเงินว่าด้วยการ
                                    <br />
                                    จัดให้มีการฝึกอบรมให้แก่ผู้มีหน้าที่รายงาน
                                    <br />
                                    ตามมาตรา ๑๓ และมาตรา ๑๖ พ.ศ. ๒๕๖๓
                                </p>
                                <p class="date">ให้ไว้ ณ วันที่ {{ $PPlusEngine.getDateText(fields.passDate, 'TH') }}</p>
                                <div class="signature"><img src="@/assets/signature.png" /></div>
                                <p class="signature-line"></p>
                                <p class="signature-text">
                                    กรรมการผู้จัดการ
                                    <br />
                                    บริษัท โปรเฟสชั่นแนล บี โพสิทีฟ จำกัด
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="certificate-container">
                        <div class="certificate" ref="panelCertificateEN">
                            <div class="wrapper">
                                <div class="logo"><img src="@/assets/cert-logo.jpg" /></div>
                                <h2>Professional be Positive Co.,Ltd.</h2>
                                <p class="give-text">This certifcate is presented to</p>
                                <p class="name">{{ fields.fullnameEN }}</p>
                                <p class="topic-text">For Successfully Completing Courses of</p>
                                <p class="topic">AML/CTPF : Anti-Money Laundering and Counter Terrorism and Proliferation of Weapon of Mass Destruction Financing</p>
                                <p class="topic-sub-text">Certified by the Anti-Money Laundering Office (Thailand)</p>
                                <p class="date">{{ $PPlusEngine.getDateText(fields.passDate, 'EN') }}</p>
                                <div class="signature"><img src="@/assets/signature.png" /></div>
                                <p class="signature-line"></p>
                                <p class="signature-text">
                                    Managing Director
                                    <br />
                                    Professional be Positive Co.,Ltd.
                                </p>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
        </div>
    </UserBase>
</template>

<script>
import UserBase from '@/pages/UserBase';
import ContentLoader from '@/weact/components/ContentLoader';
import domtoimage from 'dom-to-image';

export default {
    components: {
        UserBase,
        ContentLoader
    },
    data() {
        return {
            contentReady: false,
            fields: {},
            currentLang: 'TH',
            fileThumbLoader: 2,
            fileThumbTH: '',
            fileThumbEN: ''
        }
    },
    created() {
        let page = this;
        
        setTimeout(function(){
            page.getContent();
        }, this.$WeConfig.TimeLoader);
    },
    methods: {
        getContent() {
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {};

            this.$WeHelper.postAPI(apiURL, '/api/user/get-certificate-content', postData, this.$PPlusEngine.getHeaderToken()).then((response) => {
                this.fields = response.data;
                this.contentReady = true;

                if (this.fields.allowDownload) {
                    setTimeout(() => {
                        domtoimage.toPng(this.$refs.panelCertificateTH).then((dataUrl) => {
                            this.fileThumbTH = dataUrl;
                            this.fileThumbLoader--;
                        });
                        domtoimage.toPng(this.$refs.panelCertificateEN).then((dataUrl) => {
                            this.fileThumbEN = dataUrl;
                            this.fileThumbLoader--;
                        });
                    }, this.$WeConfig.TimeLoader);
                }
            });
        },
        async downloadPDF() {
            let loader = this.$WeHelper.modalLoad();
            let apiURL = this.$PPlusConfig.ApiURL;

            const response = await this.$WeHelper.getBlobAPI(apiURL, '/api/certificate/download?lang=' + this.currentLang.toLowerCase(), this.$PPlusEngine.getHeaderToken());

            loader.hide();

            let fileName = 'Certificate.pdf';

            const disposition = response.headers['content-disposition'];

            if (disposition && disposition.includes('filename=')) {
                const match = disposition.match(/filename="?([^"]+)"?/);
                if (match && match[1]) {
                    fileName = decodeURIComponent(match[1]);
                }
            }

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const link = document.createElement('a');

            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', fileName);
            
            document.body.appendChild(link);

            link.click();
            link.remove();
        }
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.page-user-certificate {
    h1 {
        font-size: 22px;
        color: $mainColor;
        margin: 0 0 15px;
        border-bottom: 1px solid #eee;

        span {
            display: inline-block;
            margin-bottom: -1px;
            padding-bottom: 10px;
            border-bottom: 2px solid $mainColor;
        }
    }

    .not-allow {
        margin-top: 30px;
        border: 1px dashed #ccc;
        padding: 100px 10px;
        font-size: 24px;
        font-weight: 200;
        text-align: center;
        color: #aaa;

        i {
            display: block;
            color: #e5e5e5;
            margin-bottom: 40px;
            font-size: 150px;
        }
    }
    
    .certificate-container {
        position: fixed;
        left: 0;
        z-index: -1;
        overflow: hidden;
        opacity: 0;
    }

    .certificate {
        margin: 0 auto;
        overflow: hidden;
        background: #fff;
        width: 21cm;
        height: 29.7cm;
        padding: 0.5cm 1cm;

        .wrapper {
            padding-top: 30px;
        }

        .logo {
            text-align: center;

            img {
                display: inline-block;
                height: 80px;
            }
        }

        h2 {
            font-size: 22px;
            font-weight: bold;
            font-family: 'Sarabun';
            padding-top: 20px;
            text-align: center;
            margin: 0;
            line-height: normal;
            color: #000;
            border-bottom: none;
        }

        p {
            margin: 0;
            padding: 0;
            line-height: normal;
            text-align: center;
            font-family: 'Sarabun';
            font-size: 22px;
            
            &.give-text {
                font-size: 22px;
                padding-top: 60px;
            }

            &.name {
                font-size: 22px;
                font-weight: bold;
                padding: 80px 0;
            }

            &.topic {
                font-weight: bold;
                padding: 20px 0;
                padding-left: 30px;
                padding-right: 30px;
            }

            &.date {
                font-size: 22px;
                font-weight: bold;
                padding-top: 70px;
            }

            &.signature-line {
                width: 400px;
                margin: auto;
                border-bottom: 1px solid #333;
            }

            &.signature-text {
                font-size: 18px;
                padding-top: 15px;
            }
        }

        .signature {
            padding-top: 60px;

            img {
                display: block;
                margin: auto;
            }
        }
    }

    .paper {
        margin-top: 30px;

        .thumbnail {
            border: 1px solid #eee;

            img {
                display: block;
                width: 100%;
            }
        }

        .action {
            margin-top: 20px;
            overflow: hidden;

            .lang {
                float: left;

                @media only screen and (max-width: $screenSmall) {
                    float: none;
                    padding-bottom: 5px;
                }

                label {
                    @include verticalAlign(middle);
                    margin: 0 10px 0 0;
                    font-size: 14px;
                    color: #999;
                }

                .group {
                    @include verticalAlign(middle);
                    overflow: hidden;

                    button {
                        float: left;
                        background: #fff;
                        border: 1px solid $mainColor;
                        font-size: 14px;
                        color: $mainColor;
                        outline: none;
                        padding: 7px 10px;

                        &.active {
                            background: $mainColor;
                            color: #fff;
                        }
                    }
                }
            }

            .download {
                float: right;
                text-align: right;

                @media only screen and (max-width: $screenSmall) {
                    float: none;
                    text-align: left;
                }

                .btn {
                    margin-left: 5px;

                    &:focus {
                        outline: none;
                    }

                    @media only screen and (max-width: $screenSmall) {
                        display: block;
                        width: 100%;
                        margin: 3px 0 0;
                    }
                }
            }
        }
    }
}
</style>